import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Row = styled.div`
  display: contents;
`;

export const LabelColumn = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const IconContainer = styled.span`
  font-size: 1.2rem;
  line-height: 62.5%;
`;

export const Label = styled.span`
  white-space: nowrap;
`;

export const Value = styled.span<{
  $isClickable?: boolean;
  $isPlaceholder?: boolean;
}>`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  justify-self: start;
  min-width: 0;
  max-width: 100%;

  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(1.5)}`};
  border-radius: ${({ theme }) => theme.spacing(2)};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme, $isPlaceholder }) =>
    $isPlaceholder ? theme.palette.text.secondary : theme.palette.text.primary};

  ${({ theme, $isClickable }) =>
    $isClickable &&
    css`
      cursor: pointer;

      &:hover {
        background: ${theme.palette.grey[100]};
      }
    `};
`;
